class Ft {

    constructor(apiService = null) {
        this.obj_name = 'ft';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'delete') {
                this.apiService.delApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 送出前檢查表單填寫格式
    checkFromModel(formData) {
        const validations = [
            { condition: formData.form_name === '', message: '請輸入表單名稱' },
            { condition: formData.species_json.length <= 0, message: '請添加物種' },
            { condition: formData.form_json.length <= 0, message: '請輸入評估項目' },
        ];
        
        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // API 方法
    //野放評估 | 101新增野放評估
    async addFieldTrainingForm(parameter , progressEvent = null) {
        return this.callApi('post', 'addFieldTrainingForm', parameter , progressEvent);
    }
    //野放評估 | 102取得野放評估詳細資料
    async getFieldTrainingFormDetail(parameter) {
        return this.callApi('get', 'getFieldTrainingFormDetail', parameter);
    }
    //野放評估 | 103更新野放評估
    async updAddOrDelFieldTrainingForm(parameter, progressEvent = null) {
        return this.callApi('post', 'updAddOrDelFieldTrainingForm', parameter, progressEvent);
    }
    //野放評估 | 104搜尋野放評估表單
    async getFieldTrainingFormByKeywordWithPage(parameter) {
        return this.callApi('get', 'getFieldTrainingFormByKeywordWithPage', parameter );
    }
    // 野放評估 | 105取得野訓計劃詳細資料
    async getFieldTrainingDetailByFieldTrainingId(parameter) {
        return this.callApi('get', 'getFieldTrainingDetailByFieldTrainingId', parameter);
    }
    //野放評估 | 106新增野放訓練計劃
    async addFieldTraining(parameter,progressEvent = null) {
        return this.callApi('post', 'addFieldTraining', parameter , progressEvent);
    }
    //野放評估 | 107更新野放訓練計劃
    async updFieldTraining(parameter,progressEvent = null) {
        return this.callApi('post', 'updFieldTraining', parameter , progressEvent);
    }
    //野放評估 | 108新增野放評估紀錄
    async addFieldTrainingAssessmentByJson(parameter,progressEvent = null) {
        return this.callApi('post', 'addFieldTrainingAssessmentByJson', parameter , progressEvent);
    }
    //野放評估 | 109更新野放評估紀錄
    async updFieldTrainingAssessmentByJson(parameter,progressEvent = null) {
        return this.callApi('post', 'updFieldTrainingAssessmentByJson', parameter , progressEvent);
    }
    //野放評估 | 109更新野放評估紀錄
    async updFieldTrainingAssessmentByJson(parameter,progressEvent = null) {
        return this.callApi('post', 'updFieldTrainingAssessmentByJson', parameter , progressEvent);
    }
    //野放評估 | 110取得待野放清單
    async getFieldTrainingWaitingRewilding(parameter) {
        return this.callApi('get', 'getFieldTrainingWaitingRewilding', parameter);
    }
    //野放評估 | 111野放
    async addRewilding(parameter,progressEvent = null) {
        return this.callApi('post', 'addRewilding', parameter , progressEvent);
    }
    //野放評估 | 112搜尋野放列表
    async getRewildingByKeywordWithPage(parameter) {
        return this.callApi('get', 'getRewildingByKeywordWithPage', parameter);
    }
    //野放評估 | 113搜尋野放訓練列表(分類)
    async getFieldTrainingByTypeAndKeywordWithPage(parameter) {
        return this.callApi('get', 'getFieldTrainingByTypeAndKeywordWithPage', parameter);
    }
    //野放評估 | 114取得野放評估紀錄詳細資料
    async getFieldTrainingAssessmentByFTAId(parameter) {
        return this.callApi('get', 'getFieldTrainingAssessmentByFTAId', parameter);
    }
}
export default Ft;